"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetExpandable = void 0;
exports.WidgetExpandable = {
    Never: "never",
    Mobile: "mobile",
    Desktop: "desktop",
    Always: "always",
};
